//#region libraries
import React from 'react';

// drop down menu
import Select from "react-select";

//redux
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultCheckInLocation, selectDefaultCheckInLocation, selectDefaultArrivalCheckInLocation, setDefaultArrivalCheckInLocation } from '_redux/slices/timeline/timeline-control';
import { selectPickUpLocations } from '_redux/slices/timeline/timeline-areas';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// styling
import { Spacing } from '_styles';
//#endregion

const AutoCheckInLocation = (props) => {

    //redux
    const dispatch = useDispatch();
    const pickUpLocations = useSelector(selectPickUpLocations);                     // airport pick up locations
    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation);
    const defaultArrivalCheckInLocation = useSelector(selectDefaultArrivalCheckInLocation);
    const usedTheme = useSelector(selectUsedTheme);

    const Title = "Default Departures check-in location";

    const formatSelectValue = (id) => {

        let tempPickUp = pickUpLocations?.find(loc => loc?._id == id);
        if (tempPickUp) {
            return {
                value: tempPickUp?._id,
                label: tempPickUp?.title
            }
        } else {
            return null;
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "10px" }} data-tippy-content="Set the Default Option When Checking A Departure Passenger In">
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        {props?.upperCase ? Title.toUpperCase() : Title}
                    </span>
                    <Select
                        value={formatSelectValue(defaultCheckInLocation)}
                        onChange={(selectedOption) => dispatch(setDefaultCheckInLocation(selectedOption?.value))}
                        options={pickUpLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose a Location..."
                        styles={{
                            control: (base) => ({
                                ...base,
                                minWidth: "200px",
                                borderRadius: "5px",
                                zIndex: 100,
                                backgroundColor: usedTheme.BACKGROUND_COLOR,
                                borderColor: usedTheme.BORDER_COLOR,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            placeholder: (provided) => ({
                                ...provided,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            singleValue: (provided) => ({
                                ...provided,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 4,
                                backgroundColor: usedTheme.BACKGROUND_COLOR,
                                borderColor: usedTheme.BORDER_COLOR,
                                color: usedTheme.TEXT_COLOR
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                    ? usedTheme.BORDER_COLOR
                                    : usedTheme.BACKGROUND_COLOR,
                                color: usedTheme.TEXT_COLOR,
                                cursor: 'pointer',
                            }),
                        }}
                        isClearable
                    />
                </div>
                {props?.showSubtitle !== false && <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select your default location for departure passengers checkin.
                </span>}
            </div>
            <div className='mt-5' style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "10px" }} data-tippy-content="Set the Default Option When Checking An Arrival Passenger In">
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        {"Default Arrivals check-in location"}
                    </span>
                    <Select
                        value={formatSelectValue(defaultArrivalCheckInLocation)}
                        onChange={(selectedOption) => dispatch(setDefaultArrivalCheckInLocation(selectedOption?.value))}
                        options={pickUpLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose a Location..."
                        styles={{
                            control: (base) => ({
                                ...base,
                                minWidth: "200px",
                                borderRadius: "5px",
                                zIndex: 100,
                                backgroundColor: usedTheme.BACKGROUND_COLOR,
                                borderColor: usedTheme.BORDER_COLOR,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            placeholder: (provided) => ({
                                ...provided,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            singleValue: (provided) => ({
                                ...provided,
                                color: usedTheme.TEXT_COLOR,
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 4,
                                backgroundColor: usedTheme.BACKGROUND_COLOR,
                                borderColor: usedTheme.BORDER_COLOR,
                                color: usedTheme.TEXT_COLOR
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                    ? usedTheme.BORDER_COLOR
                                    : usedTheme.BACKGROUND_COLOR,
                                color: usedTheme.TEXT_COLOR,
                                cursor: 'pointer',
                            }),
                        }}
                        isClearable
                    />
                </div>
                {props?.showSubtitle !== false && <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select your default location for arrival passengers checkin.
                </span>
                }
            </div>
        </div>
    )
}

export default AutoCheckInLocation